export default function IconTop() {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.07851 0.684204L15.736 13.9474L8.07851 10.7895L0.421021 13.9474L8.07851 0.684204Z" fill="currentColor" />
    </svg>
  );
}
